import hero from "../images/support_hero.png";
import sc_logo_desk from "../images/logo_home_mobile.png";

// import MaternityMates_logo from "../images/MaternityMates_Icon.png";
import MaternityMates_logo from "../images/maternityMates_Logo2.svg";
import HerHealth_logo from "../images/herHealth_Logo2.svg";
import HealingConversations_logo from "../images/healingConversation_Logo2.svg";
// import PeerSupportGroup_logo from "../images/PeerSupportGroup_Icon.png";
// import ConversationCafe_logo from "../images/HerHealth_Icon.png";
// import traumaCounselling from "../images/_support_healing.png";
import maternity_hero from "../images/support_maternity.png";
import women_hero from "../images/about_women.png";
import herhealth_hero from "../images/support_herhealth.png";
// import healing_hero from "../images/about_impact2.jpg";
import peer_hero from "../images/support_peer.png";
import cafe_hero from "../images/support_cafe.png";
import impact2_hero from "../images/about_impact2.jpg";

import Navbar from "../sections/Navbar.js";
import Footer from "../sections/Footer.js";
import { useRef, useState, useCallback } from "react";
// import YouTubeVideo from "../components/YouTubeVideo";
import useScrollToSection from "../hooks/useScrollToSection";
import YouTubeVideo from "../components/YouTubeVideo";
import SectionReveal from "../components/SectionReveal";

// ── Toggle: set to true for scroll-triggered fade-up on content sections ──
const showSectionReveal = true;

const Support = () => {
  // Refs for scroll navigation to different support sections
  const supportPageRef = useRef();
  const maternityComponent = useRef();
  // const femaleComponent = useRef();
  const healingComponent = useRef();
  const herHealthComponent = useRef();
  const conversationCafeComponent = useRef();

  // Track navbar overlay state for logo z-index toggle
  const [isNavOverlayActive, setIsNavOverlayActive] = useState(false);
  const handleOverlayActive = useCallback((active) => {
    setIsNavOverlayActive(active);
  }, []);

  // Use custom hook to handle URL-based scrolling to sections
  useScrollToSection({
    "Maternity-Mates": maternityComponent,
    // "Female-Genital-Cutting-Support": femaleComponent,
    "Healing-Conversations": healingComponent,
    "Her-Health": herHealthComponent,
    "Conversation-Cafe": conversationCafeComponent
  });

  return (
    <div className="">
      <Navbar whichRef={supportPageRef} currentPage="support" onOverlayActive={handleOverlayActive} />
      
      {/* ===============================================================================================================
           HERO SECTION - Get Support Page Header
           =============================================================================================================== */}
      <div className="bg-[#DCB1FA]">
        <div className="mx-auto max-w-[1240px]">
          {/* Logo */}
          <a href="/" className="0">
            <img
              src={sc_logo_desk}
              className={`xs:mt-6 md:ml-6 s:ml-12 xs:ml-8 responsive-home-logo-width sm:w-[110px] ss:w-[110px] s:w-[100px] xs:w-[90px] absolute top-0 ${isNavOverlayActive ? '' : 'z-[22]'}`}
              alt="sister-circle-logo"
            />
          </a>

          <div className="flex md:flex-row items-center w-full bg-[#DCB1FA] overflow-hidden">
            {/* Page Title */}
            <div className="max-w-[1240px] absolute md:mb-0 md:mt-0 w-[100%]">
              <h1 className="xs:z-10 xs:relative md:static md:ml-0 xs:text-left md:text-center xs:mb-0 xs:mr-0 xs:ml-[2rem] s:ml-[3rem] sm:ml-[4rem] md:mt-0 font-sans antialiased mds:text-[4.8rem] mds:leading-[2.2rem] s:text-[3rem] xss:text-[2.8rem] xss:leading-[2.2rem] align-middle text-[#b24029]">
                Get support
              </h1>
            </div>

            {/* Hero Image */}
            <div className="md:mt-0 md:mb-0 w-[100%]">
              <img
                src={hero}
                className="xs:relative md:static ss:left-[20%] xs:left-[15%] md:left-0 xs:mx-auto md:min-h-[388px] md:max-h-[100vh] ss:h-[100%] xs:h-[188px] ss:mt-0 xs:mt-[18%] hero-img float-right"
                alt="hero"
              />
            </div>
          </div>
        </div>
      </div>

      {/* ===============================================================================================================
           MATERNITY MATES - Pregnancy, Labour & Postnatal Support
           =============================================================================================================== */}
      <div ref={supportPageRef} className="bg-[#ffe1d9]">
        <div
          ref={maternityComponent}
          className="mx-auto max-w-[1240px] responsive-maternity-pt"
        >
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col-reverse xs:items-center md:items-start md:flex-row  md:w-full bg-[#ffe1d9] md:min-h-[550px] overflow-hidden">
            <div className="   xs:mb-[0vh] xs:mt-[0vh] md:mt-0  md:mb-0 xs:w-[95%] md:w-[40%] md:ml-0 xs:ml-[5%]">
              <img
                src={maternity_hero}
                className=" xs:mx-auto max-h-[671px] block "
                alt="maternity 1"
              />
            
            </div>

            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className=" xs:mb-[0vh]  md:mt-0  md:mb-0  xs:w-4/5 md:w-[58%] x1270:mx-[1.5rem] md:mr-[1.5rem]">
              <img
                src={MaternityMates_logo}
                className="responsive-logo-height mb-6 md:ml-7"
                alt="Maternity Mates"
              />
        
              <p className="module-subhead  w-[95%] ">
                Support during pregnancy, birth and early parenthood
              </p>
              <p className="module-bodycopy  w-[95%]">
               Sister Circle provides one-to-one pregnancy, labour and postnatal support to expectant mothers by providing a dedicated ‘Maternity Mate’ to walk beside them, with the aim of securing the best possible start for mother and baby.
               <br /><br /> 
                We support women who find themselves alone; refugees or new migrants, homeless or living in temporary accommodation, survivors of gender based violence, trafficking or domestic abuse, or facing healthcare barriers because English is not a first language. Our caring, local, female volunteers are fully trained to provide expectant mothers with practical and emotional support.
                <br/><br />
                Maternity Mates is provided in Tower Hamlets, Newham, Waltham Forest and Croydon. To receive support or to refer someone who would benefit from our help, please fill in this private and confidential form.
              
                </p>
              
               <div className="ctabox ctabox-width rounded-full rounded-l-lg ">
                    
                    <p className="ctabox-copy">
                    
                    <button className="ctabox-button">
                      <a
                    href="https://sistercirclelondon.typeform.com/SisterCircleRef?"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Get Maternity Mates support
                  </a>
                    </button>
              
                    <ol className="list-none ml-0 mt-[5px] mb-[0px]">
                      <li className="pb-1">
                      <span>Email: </span>
                      <a
                      className="underline"
                      href="mailto:Maternity.mates@sistercircle.org.uk"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Maternity.mates@sistercircle.org.uk
                    </a>
                      </li>
                    <li className="pb-1">
                    <span>or call </span>
                      <a className="underline" href="tel:07548 832039">
                      07548 832039
                      </a>
                    </li>
                    </ol>
                    </p>
                  </div>
              <div className="xs:mb-[2.5rem] md:mb-0"> <p className="module-subhead  w-[95%] ">
                                Become a Maternity Mate<br />
                  </p>
                  <p className="module-bodycopy  w-[95%]">
                If you would like to support pregnant women in your local area, please visit our&nbsp;
                  <span>
                  <a
                    className="underline"
                    href="/volunteer-with-us"
                    rel="noreferrer"
                    target="_self"
                  >
                    Volunteering section
                  </a>
                </span>
                .</p>
              </div>
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>

        {/* ===============================================================================================================
           QUOTE - New Mum
           =============================================================================================================== */}
      <div className="bg-[#ffe1d9]">
        <div className="mx-auto max-w-[1240px] xs:w-4/5 md:w-full md:px-[1.5rem] min-[1270px]:pl-[4.5rem] xs:pt-[3rem] md:pt-[3rem] xs:pb-[0rem] md:pb-[0rem]">
          <SectionReveal enabled={showSectionReveal}>
          <p className="module-quote">
            <span className="module-quote-highlight">
              &ldquo;My Maternity Mate made me feel safe. I trusted her completely and she never once let me down. She means so much to me, and she always will&rdquo;
            </span>
          </p>
          <div className="xs:mt-6 md:mt-8">
            <span className="text-[#b24029] text-[1.5rem] leading-none">—</span>
            <p className="module-bodycopy w-[95%] ml-0 mt-0" style={{ fontSize: 'clamp(22px, calc(16.86px + 0.669vw), 26px)', lineHeight: 'clamp(26.4px, calc(20.23px + 0.803vw), 31.2px)' }}>
              A new Mum
            </p>
          </div>
          </SectionReveal>
        </div>
      </div>

        {/* ===============================================================================================================
           MATERNITY MATES - Section 2 Support for new parents
           =============================================================================================================== */}
      <div  className="bg-[#ffe1d9]">
        <div className="mx-auto max-w-[1240px] xs:pt-[3.5rem] md:pt-[3.5rem] ">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col-reverse xs:items-center md:items-start md:flex-row w-full bg-[#ffe1d9] md:min-h-[550px] overflow-hidden">
       
            <div className="    xs:mt-10 md:mt-0  md:mb-0 xs:w-[95%] md:w-[40%] xs:mr-auto xs:ml-[5%] md:ml-0 ">
              <img
                src={women_hero}
                className=" md:mx-auto xs:mx-auto max-h-[671px] "
                alt="women_hero"
              />
            </div>

            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className=" xs:mb-[0vh] xs:mt-[0vh] md:mt-0  md:mb-0 xs:w-4/5 md:w-[58%] x1270:mx-[1.5rem] md:mr-[1.5rem]">
           
              <p className="module-subhead w-[95%] mt-0 ">
               Support for new parents
              </p>
              <p className="module-bodycopy w-[95%]">
              Alongside our Maternity Mates support, we invite women, partners, and families to also join our free Preparation for Parenthood antenatal courses (in English or Bengali) to help you prepare for your new arrival.<br /><br />
              Following the birth, mums are invited to our postnatal group meeting every second and fourth Wednesday of the month at a Family hub in Tower Hamlets. At these sessions, mothers can meet new friends and find support on topics such as infant feeding, early years development, and find out about other local services. We provide refreshments, activities, toys and floor play for the babies. We also hold 'Starting Solids' workshops to support parents as they begin introducing solid foods into their baby's diet.<br /><br />
              To find out more about Sister Circle’s pre- and postnatal support, please contact us directly or fill in this private and confidential form.
              </p>

              <div className="ctabox ctabox-width  text-[#B24029] bg-[#DCB1FA] xs:mb-0 ">
                <button className="ctabox-button  text-[#B24029] border-[#B24029] font-medium">
                   
                      <a
                        href="https://sistercirclelondon.typeform.com/SisterCircleRef?"
                        rel="noreferrer"
                        target="_blank"
                      >
                        Get support for new parents 
                      </a>
                    </button>
               
                <p className="ctabox-copy ">
                  Email: <span>
                  <a
                    className="underline"
                    href="mailto:parenthood@sistercircle.org.uk"
                    rel="noreferrer"
                    target="_blank"
                  >
                    parenthood@sistercircle.org.uk
                  </a>
                </span>
                  
                  <br></br>
                  <span>or call </span>
                  <span>
                    <a className="underline" href="tel:07548832050">
                      07548 832050
                    </a>
                  </span>
                  <br></br>
                </p>
              </div>
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>

          {/* ===============================================================================================================
           Healing Conversations - Maternal Mental Health peer support
           =============================================================================================================== */}
      <div ref={healingComponent} className="bg-[#ffe1d9]">
        <div className="mx-auto max-w-[1240px] responsive-maternity-pt">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col md:flex-row xs:items-center md:items-start w-full bg-[#ffe1d9] md:min-h-[550px] overflow-hidden">
            {/* Left Column: Service Content */}
            <div className=" module-left xs:mb-[0vh] xs:mt-[0vh] md:mt-0 md:mb-0 xs:w-4/5 md:w-[60%]">
              {/* Service Icon */}
              <img
                src={HealingConversations_logo}
                className="responsive-logo-height2 mb-6"
                alt="sister-circle-logo"
              />

              {/* Service Title */}
              {/* <h1 className="module-headline module-left md:w-[79%] xs:w-[100%]">
                Healing Conversations
              </h1> */}

              {/* Service Subheading */}
              <p className="module-subheadL w-[100%]">
                Maternal mental health peer support<br></br>
              </p>

              {/* Service Description & Clinic Information */}
              <p className="module-bodycopyL  w-[100%]">
              We hold group sessions dedicated to shared experiences of pregnancy loss, birth trauma or infant loss. Facilitated by lived-experience volunteers who are passionate about supporting others, our peer groups understand the value of women supporting women. Here, women can begin to heal together. Each woman is listened to carefully and thoughtfully to to best support her healing journey.<br/><br />
                Our dedicated groups are held in local venues in Tower Hamlets, Newham and Waltham Forest. To receive support or to refer someone who would benefit from our help, please fill in this private and confidential form.

              </p>
              {/* Call-to-Action Box */}
                <div className="bg-[#b24029] xs:mb-[0vh] xs:pr-4 xs:pl-7 md:px-0 m pt-10 pb-[4rem] xs:mt-10 md:mt-10  md:mb-0  ctabox-width  rounded-full rounded-l-lg max-w-[500px]">
                  <p className="ctabox-circle xs:w-[70%] md:w-[60%] mds:w-[70%]   xs:mt-0 xs:mr-0 xs:ml-0 md:mt-0 md:mr-6 md:ml-7  font-sans antialiased  tracking-[-0.01em] align-middle text-[#ffe1d9]">
              
                </p>

                <button className="ctabox-button2">
                {/* <button className="mt-6 mb-6 xs:mr-0 xs:ml-0  md:mr-0 md:ml-7 block px-5 py-[0.4rem] s:text-base xs:text-xs font-medium text-center text-[#F7E1DA] border-2 border-[#F7E1DA] rounded-full"> */}
                  <a
                    href="https://sistercirclelondon.typeform.com/SisterCircleRef?"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Get Peer Support 
                  </a>
                </button>
                <p className=" ctabox-circle  xs:mt-0 xs:mr-0 xs:ml-0 md:mt-0 md:mr-6 md:ml-7  font-sans antialiased  tracking-[-0.01em] align-middle text-[#ffe1d9]">
                  Email: <span>
                    <a
                      className="underline"
                      href="mailto:healing.conversations@sistercircle.org.uk"
                      rel="noreferrer"
                      target="_blank"
                    >
                      healing.conversations@sistercircle.org.uk
                    </a>
                  </span>
                 
                  <br></br>
                  <span>or call </span>
                  <span>
                    <a className="underline" href="tel:07469 581142">
                      07469 581142
                    </a>
                  </span>
                </p>
              </div>
            </div>

            {/* Right Column: Image & CTA Box */}
            <div className="md:mr-0 md:mb-[0vh] md:mt-[0vh] xs:mb-[0vh] xs:mt-10 xs:w-[95%] md:w-[40%] xs:mr-auto  xs:ml-[5%] md:ml-0">
              {/* Service Image */}
              <img
                src={peer_hero}
                className=" max-h-[671px] h-[auto] mx-auto"
                alt="hero"
              />
            
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>

     {/* ===============================================================================================================
          QUOTE - Survivor of loss
           =============================================================================================================== */}
      <div className="bg-[#ffe1d9]">
        <div className="mx-auto max-w-[1240px] xs:w-4/5 md:w-full md:px-[1.5rem] min-[1270px]:pl-[4.5rem] xs:pt-[3rem] md:pt-[3rem] xs:pb-[0rem] md:pb-[0rem]">
          <SectionReveal enabled={showSectionReveal}>
          <p className="module-quote">
            <span className="module-quote-highlight">
              &ldquo;...I felt like I could breathe a little again for the first time in three weeks.&rdquo;
            </span>
          </p>
          <div className="xs:mt-6 md:mt-8">
            <span className="text-[#b24029] text-[1.5rem] leading-none">—</span>
            <p className="module-bodycopy w-[95%] ml-0 mt-0" style={{ fontSize: 'clamp(22px, calc(16.86px + 0.669vw), 26px)', lineHeight: 'clamp(26.4px, calc(20.23px + 0.803vw), 31.2px)' }}>
              A survivor of loss
            </p>
          </div>
          </SectionReveal>
        </div>
      </div>

     {/* ===============================================================================================================
          Long-term trauma counselling in community languages.
           =============================================================================================================== */}
           <div className="bg-[#ffe1d9]">
            <div className="mx-auto max-w-[1240px]  xs:pt-14 md:pt-14">
              <SectionReveal enabled={showSectionReveal}>
              <div className="flex xs:flex-col md:flex-row xs:items-center md:items-start w-full bg-[#ffe1d9] md:min-h-[550px] overflow-hidden">
                {/* Left Column: Service Content */}
                <div className=" module-left xs:mb-[0vh] xs:mt-[0vh] md:mt-0 md:mb-0 xs:w-4/5 md:w-[60%]">
                  {/* Service Icon */}
                
                  {/* Service Subheading */}
                  <p className="module-subheadL w-[100%] mt-0">
                  One-to-one trauma counselling<br></br>
                  </p>

                  {/* Service Description & Clinic Information */}
                <p className="module-bodycopyL w-[100%]">
                    Sister Circle provides trauma-informed and culturally sensitive one-to-one counselling sessions for women who have experienced any form of gender-based violence, birth trauma, or pregnancy loss. We also offer a dedicated and highly specialised service for survivors of female genital mutilation/cutting (FGM/C). Counselling is available is English, Somali (both dialects), Bengali (both dialects), Italian, Hindi and Urdu.<br /><br /> 
                    Here you can listen to the real stories of women who've survived FGM/C and their experience of accessing trauma counselling to see just how crucial this can be in their healing journey.
                    <br/><br />
                    Trauma counselling is available for women in Tower Hamlets and pan-London for those impacted by any form of gender based violence and in safe accommodations. To receive support or to refer someone who would benefit from our help, please fill in this private and confidential form.

                  </p>
                  {/* Call-to-Action Box */}
                    <div className=" bg-[#DCB1FA] text-[#B24029] xs:mb-[0vh] xs:pr-4 xs:pl-7 md:px-0 pt-10 pb-[4rem] xs:mt-10 md:mt-10  md:mb-0  ctabox-width ">
                      <p className="ctabox-circle xs:w-[70%] md:w-[60%] mds:w-[70%]   xs:mt-0 xs:mr-0 xs:ml-0 md:mt-0 md:mr-6 md:ml-7  font-sans antialiased  tracking-[-0.01em] align-middle text-[#ffe1d9]">
                  
                    </p>

                    <button className="ctabox-button2  text-[#B24029] border-[#B24029] font-medium">
                   
                      <a
                        href="https://sistercirclelondon.typeform.com/SisterCircleRef?"
                        rel="noreferrer"
                        target="_blank"
                      >
                        Get Trauma Counselling 
                      </a>
                    </button>
                    <p className=" ctabox-circle  xs:mt-0 xs:mr-0 xs:ml-0 md:mt-0 md:mr-6 md:ml-7  font-sans antialiased  tracking-[-0.01em] align-middle  text-[#B24029] ">
                      Email: <span>
                        <a
                          className="underline"
                          href="mailto:counselling@sistercircle.org.uk"
                          rel="noreferrer"
                          target="_blank"
                        >
                          counselling@sistercircle.org.uk
                        </a>
                      </span>
                    
                      <br></br>
                      <span>or call </span>
                      <span>
                        <a className="underline" href="tel:07909 803728">
                          07909 803728
                        </a>
                      </span>
                    </p>
                  </div>
                </div>

                {/* Right Column: Image & CTA Box */}
                <div className="md:mr-0 md:mb-[0vh] md:mt-[0vh] xs:mb-[0vh] xs:mt-10 xs:w-[95%] md:w-[40%]  xs:ml-[5%] md:ml-0">
      
                   <YouTubeVideo
                videoId="kqtBXfzbul0"
                thumbnail={impact2_hero}
                title="FGM/C trauma counselling stories"
                className="max-h-[671px] max-w-[670px] mx-auto"
              />

                </div>
              </div>
              </SectionReveal>
            </div>
          </div>

      {/* ===============================================================================================================
           HER HEALTH - FGM/C Support & Specialist Clinic
           =============================================================================================================== */}

          <div  ref={herHealthComponent} className="bg-[#ffe1d9]">
            <div
              
              className="mx-auto max-w-[1240px] responsive-maternity-pt"
            >
              <SectionReveal enabled={showSectionReveal}>
              <div className="flex xs:flex-col-reverse xs:items-center md:items-start md:flex-row w-full bg-[#ffe1d9] md:min-h-[550px] overflow-hidden">
                <div className="   xs:mb-[0vh] xs:mt-[0vh] md:mt-0  md:mb-0 xs:w-[95%] md:w-[40%] md:ml-0 xs:ml-[5%]">
                  <img
                    src={herhealth_hero}
                    className=" xs:mx-auto max-h-[671px] block "
                    alt="her health 1"
                  />
                
                </div>

                {/* --------------------------------------------------------------------------------------------------------- */}
                <div className=" xs:mb-[0vh]  md:mt-0  md:mb-0  xs:w-4/5 md:w-[58%] x1270:mx-[1.5rem] md:mr-[1.5rem]">
                  <img
                    src={HerHealth_logo}
                    className="responsive-logo-height mb-6 md:ml-7"
                    alt="Her Health logo"
                  />
                
                  
                  <p className="module-subhead  w-[95%]">
                    Specialist clinical support following gender-based violence<br></br>
                  </p>
                  <p className="module-bodycopy  w-[95%]">
                  Thousands of women and girls across the UK continue to live with the long-term impacts of gender-based violence including female genital mutilation/cutting (FGM/C); a violation of Women’s Human Rights.<br/><br />
                      Our free specialist clinic, run by an all-female team, offers expert, compassionate care in a safe, confidential, and non-judgmental setting. Our team includes consultant gynaecologists, a specialist midwife, trained health advocates, counsellors, and interpreters, including Somali-speaking staff. We understand the cultural and emotional complexities surrounding gender-based violence and FGM/C and are here to support you with dignity and respect.<br /> <br />
                      Sister Circle advocates for women’s health rights, options, and care, helping women to be heard by healthcare professionals and services, ensuring dignity and appropriate treatment. We visit healthcare teams, schools, and attend men-only/women-only groups from FGM practising communities to hold education and awareness sessions around this illegal practice. Please contact us if you would like to arrange an educational session for your organisation.<br /><br />
                      To receive support, education or to refer someone who would benefit from our help, please fill in this private and confidential form.
                    </p>
                    
                  
                  <div className="ctabox ctabox-width rounded-full rounded-l-lg md:mb-0 ">
                    
                    <p className="ctabox-copy">
                    
                    <button className="ctabox-button">
                      <a
                        href="https://sistercirclelondon.typeform.com/SisterCircleRef?"
                        rel="noreferrer"
                        target="_blank"
                      >
                        Get Her Health support
                      </a>
                    </button>
              
                    <ol className="list-none ml-0 mt-[5px] mb-[0px]">
                      <li className="pb-1">
                      <span>Email: </span>
                        <a
                          className="underline"
                          href="mailto:herhealth@sistercircle.org.uk"
                          rel="noreferrer"
                          target="_blank"
                        >
                          herhealth@sistercircle.org.uk
                        </a>
                      </li>
                      <li className="pb-1">
                        <span>or call </span>
                          <a className="underline" href="tel:07960 327933">
                          07960 327933
                          </a>
                        </li>
                    </ol>
                    </p>
                  </div>
                </div>
              </div>
              </SectionReveal>
            </div>
          </div>
     
      {/* ===============================================================================================================
           CONVERSATION CAFÉ - Women's Health Education & Community Support
           =============================================================================================================== */}
      <div ref={conversationCafeComponent} className="bg-[#ffe1d9]">
        <div className="mx-auto max-w-[1240px] xs:pt-[3.5rem] md:pt-[3.5rem] md:pb-[6rem]">
          <SectionReveal enabled={showSectionReveal}>
          <div className="flex xs:flex-col-reverse xs:items-center md:items-start md:flex-row w-full bg-[#ffe1d9] md:min-h-[550px] overflow-hidden">
       
            <div className="   xs:mb-[6rem] xs:mt-10 md:mt-0  md:mb-0 xs:w-[95%] md:w-[40%] xs:mr-auto xs:ml-[5%] md:ml-0 ">
              <img
                src={cafe_hero}
                className=" md:mx-auto xs:mx-auto max-h-[671px] "
                alt="healing_image"
              />
            </div>

            {/* --------------------------------------------------------------------------------------------------------- */}
            <div className=" xs:mb-[0vh] xs:mt-[0vh] md:mt-0  md:mb-0 xs:w-4/5 md:w-[58%] x1270:mx-[1.5rem] md:mr-[1.5rem]">
           
              <p className="module-subhead w-[95%] mt-0 ">
               Conversation Café
              </p>
              <p className="module-bodycopy w-[95%]">
              Sister Circle’s Conversation Café is a warm, welcoming space where women come together to learn, share experiences, and build confidence in their health and wellbeing. Our sessions are designed especially for women from violence against women and girls (VAWG)- and FGM-affected communities, supporting them to better understand and navigate sexual and reproductive health, including menstrual health, contraception, cervical screening, and menopause.<br /><br />
              Conversation Café sessions are interactive and discussion-based. Women explore real-life scenarios, reflect on shared experiences, and learn practical ways to:<br /><br />
              <ol className="list-disc pl-4">
                  <li className="pb-3">Access local NHS services</li>
                  <li className="pb-3">Ask questions and advocate for themselves</li>
                  <li className="pb-3">Support other women safely </li>
                  <li className="pb-0">Challenge stigma and harmful myths</li>
                </ol>
                <br/>
              We work with trusted health professionals and community voices who provide short, accessible inputs to spark meaningful conversations in a safe, culturally sensitive, non-clinical environment. Our aim is to move beyond awareness, supporting women to feel informed, confident, and ready to take action when it comes to their health.<br/><br/>
              Conversation Café takes place on the second and fourth Thursday of each month at the Nari Centre in Tower Hamlets with refreshments and creche provided, alongside pop-up sessions across the borough to reach more women locally.<br/><br />  
                      To register your interest or find out about upcoming sessions please email or call us.
              </p>

              <div className="ctabox ctabox-width  text-[#B24029] bg-[#DCB1FA] xs:mb-0 ">
               
               
                <p className="ctabox-copy pt-4">
                  Email: <span>
                  <a
                    className="underline"
                    href="mailto:community.engagement@sistercircle.org.uk"
                    rel="noreferrer"
                    target="_blank"
                  >
                    community.engagement@sistercircle.org.uk
                  </a>
                </span>
                  
                  <br></br>
                  <span>or call </span>
                  <span>
                    <a className="underline" href="tel:07392393085">
                      07392 393085
                    </a>
                  </span>
                  <br></br>
                </p>
              </div>
            </div>
          </div>
          </SectionReveal>
        </div>
      </div>

      {/* ===============================================================================================================
           QUOTE - Conversation Café attendee
           =============================================================================================================== */}
      <div className="bg-[#ffe1d9]">
        <div className="mx-auto max-w-[1240px] xs:w-4/5 md:w-full md:px-[1.5rem] min-[1270px]:pl-[4.5rem]  pb-[6rem]">
          <SectionReveal enabled={showSectionReveal}>
          <p className="module-quote">
            <span className="module-quote-highlight">
              &ldquo;Being with other women makes me feel safe and strong, I can give my best&rdquo;
            </span>
          </p>
          <div className="xs:mt-6 md:mt-8">
            <span className="text-[#b24029] text-[1.5rem] leading-none">—</span>
            <p className="module-bodycopy w-[95%] ml-0 mt-0" style={{ fontSize: 'clamp(22px, calc(16.86px + 0.669vw), 26px)', lineHeight: 'clamp(26.4px, calc(20.23px + 0.803vw), 31.2px)' }}>
              A Conversation Café attendee
            </p>
          </div>
          </SectionReveal>
        </div>
      </div>

      {/* --------------------------------------------------content 5 end--------------------------------------------------- */}
      <Footer />
    </div>
  );
};

export default Support;
